import { createAction, props } from "@ngrx/store";
export const dotloopAuthDismissed = createAction('DOTLOOP_AUTH_DISMISSED');
export const dotloopAuthCompleted = createAction('DOTLOOP_AUTH_COMPLETED');
